import React from "react";
import { Tooltip } from "./Tooltip";

type Props = {
  tooltip: React.ReactNode;
  children: React.ReactNode;
};

export const UnderlineTooltipDecorator = ({ tooltip, children }: Props) => (
  <Tooltip tooltipContent={{ content: tooltip }}>
    <span style={{ textDecorationLine: "underline", textDecorationStyle: "dotted", cursor: "help" }}>
      {children}
    </span>
  </Tooltip>
);
